import routes from '@modules/parent/parent-routes';
import store from '@modules/parent/parent-store';

export default {
  routes,
  store,
};
